import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import { Offer } from '../../Offer';
import styles from '../styles/Tourist.module.scss';

export const Tourist = () => {
  const handleClick = () => {
    pushEvent(
      makeMainGEvent({
        eventCategory: 'ВЗР',
        eventAction: 'Сезонные предложения',
        eventLabel: 'Кэшбек',
        eventValue: 15,
      }),
    );
  };

  return (
    <Offer
      title={'Туристическая страховка\nдля шенгена и визы'}
      subtitle={'Защитит ваше здоровье за границей'}
      color="violet"
      href="/vzr/?promoCode=main_page_15"
      badgeText="кешбэк 15%"
      linkText="Подобрать"
      imageClassName={styles.picture}
      picture={[
        <source
          key="source-product-tourist-png"
          srcSet={require('../images/img.png')}
          media={`(min-width: ${styles.breakpointDesktop})`}
          type="image/webp"
        />,
        <img key="img-product-tourist" src={require('../images/img_mob.png')} alt="" />,
      ]}
      onClick={handleClick}
    />
  );
};
